import React from 'react'
import ModeEditIcon from '@mui/icons-material/ModeEdit'
import IconButton from '@mui/material/IconButton'
import { useStore, useResourceDefinitions, useResourceContext } from 'react-admin'

interface EditButtonProps {
  style: React.CSSProperties | undefined
  onClick: React.MouseEventHandler<HTMLButtonElement> | undefined
  disabled?: boolean
}
interface Options {
  delete: boolean
  revision: boolean
}

interface PermissionsStore {
  name?: string
  options?: Options
  hasList?: boolean
  hasCreate?: boolean
  hasEdit?: boolean
  hasShow?: boolean
}

export const EditButton = ({ style, onClick, disabled }: EditButtonProps) => {
  const propsResource = useResourceDefinitions()
  const resourceName = useResourceContext()
  let permissions: PermissionsStore | null = propsResource[resourceName]
  return (
    <>
      {permissions?.hasEdit && (
        <IconButton aria-label='edit' size='small' style={style} onClick={onClick} disabled={disabled}>
          <ModeEditIcon fontSize='inherit' />
        </IconButton>
      )}
    </>
  )
}
